<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Approval</h4>
                  <p>Enter Your User and Password</p>
                </div>

                <div>
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    disabled
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                    @keyup.enter="loginUser"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                    @keyup.enter="loginUser"
                  />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-button
                      size="large"
                      class="float-left"
                      @click="loginUser"
                      :disabled="!validateForm"
                    >Approve</vs-button>
                    <vs-button
                      size="large"
                      class="float-right"
                      color="warning"
                      @click="rejectApplication"
                      :disabled="!validateForm"
                      type="border"
                    >Reject</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <vs-prompt
      title="Reject Confirmation"
      @cancel="val=''"
      @accept="validateReason"
      :active.sync="showRejectReason"
    >
      <div class="con-exemple-prompt">
        <span>{{ rejectReasonMessage }}</span>
        <vs-input
          v-validate="'required|min:3'"
          placeholder="enter here..."
          vs-placeholder="enter here..."
          v-model="reasonModel"
          class="mt-3 w-full"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { alertMixin } from "../../mixin/alertMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
export default {
  mixins: [alertMixin, helperMixin, axiosMixin],
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      showRejectReason: false,
      rejectReasonMessage: "Why Are you Rejecting this?",
      reasonModel: "",
      payLoad: "",
      decision: "",
      endPoint: "verifyToken",
      submitEndPoint: "",
      settings: {}
    };
  },
  computed: {
    validateForm() {
      return this.email != "" && this.password != "";
    }
  },
  methods: {
    rejectApplication() {
      this.showRejectReason = true;
    },
    validateReason() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.payLoad = Object.assign(this.payLoad, {
          rejectReason: this.reasonModel,
          decision: "reject"
        });
        console.log("reason:", this.reasonModel);
        this.submitNow();
      }
    },
    submitNow() {
      //add the username and password to the payload
      Object.assign(this.payLoad, {
        email: this.email,
        password: this.password,
        token: this.$route.params.token
      });
      console.log("payload:", this.payLoad);

      this.aronPost(this.submitEndPoint, this.payLoad, "", "")
        .then(response => {
          if (response.data.status == "success") {
            this.settings.title = response.data.title;
            this.settings.message = response.data.msg;
            this.$router.push({
              name: response.data.route,
              query: this.settings
            });
          } else {
            this.errorAlert(response.data.msg);
          }

          //go back
        })
        .catch((error, response) => {
          console.log("error ActionContainer reason:", error);
          console.log("error ActionContainer response:", response);
          this.errorAlert("error", error.error);
        });
    },
    loginUser() {
      this.confirmAlert(
        "Submission",
        "Are you sure you want to approved this?"
      ).then(res => {
        this.payLoad = Object.assign(this.payLoad, {
          decision: "approve",
          rejectReason: ""
        });
        this.submitNow();
      });
    },
    verifyToken() {
      this.payLoad = { token: this.token };

      this.aronPost(this.endPoint, this.payLoad, "", "")
        .then(response => {
          this.settings.title = "Approved";
          this.settings.message = "This record has been successfully updated";
        

          if (response.data.status == "failed") {
            this.$router.push("/notFound").catch(() => {});
          }else{
            this.submitEndPoint = response.data.details.route;
            console.log("this.route:",this.submitEndPoint);
          }
        })
        .catch(error => {
          console.log("error ActionContainer reason:", error);
        });
    }
  },
  created() {
    this.token = this.$route.params.token;
    this.email = this.$route.params.email;
    console.log("this.token:", this.token);
    this.verifyToken();
  }
};
</script>
 